import { Menu as MenuIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { Logo, PageContainer } from "..";
import { useHeaderAdmin, useSidebar } from "../../hooks";

export function HeaderAdmin() {
  const { title, action, disableHeader } = useHeaderAdmin();
  const { toggle } = useSidebar();

  if (disableHeader) return;

  return (
    <PageContainer className="text-white pb-4">
      <header className="flex gap-4 items-center justify-between">
        <div className="block md:hidden">
          <Logo />
        </div>

        {title && (
          <div className="hidden md:block">
            {title && typeof title === "string" ? (
              <h2 className="text-white text-xl md:text-2xl font-bold">
                {title}
              </h2>
            ) : (
              <>{title}</>
            )}
          </div>
        )}

        {action && typeof action === "string" ? (
          <h2 className="text-white md:text-2xl font-bold">{action}</h2>
        ) : (
          <>{action}</>
        )}

        <div className="block md:hidden">
          <IconButton size="small" color="inherit" onClick={toggle}>
            <MenuIcon />
          </IconButton>
        </div>
      </header>
    </PageContainer>
  );
}
